export const ADVANCE = 'booth/ADVANCE';
export const BOOTH_SKIP = 'booth/SKIP';
export const LOAD_HISTORY_START = 'booth/LOAD_HISTORY_START';
export const LOAD_HISTORY_COMPLETE = 'booth/LOAD_HISTORY_COMPLETE';

export const ENTER_FULLSCREEN = 'playback/ENTER_FULLSCREEN';
export const EXIT_FULLSCREEN = 'playback/EXIT_FULLSCREEN';
